import React, { useState, useEffect } from "react";
import "./LoadingComponent.scss";

const LoadingComponent = () => {
  const [dotCount, setDotCount] = useState(0);

  // Animar los puntos de carga
  useEffect(() => {
    const interval = setInterval(() => {
      setDotCount((prev) => (prev + 1) % 4);
    }, 500);
    return () => clearInterval(interval);
  }, []);

  const dots = ".".repeat(dotCount);

  return (
    <div className="loading-container">
      <div className="loading-content">
        {/* Icono de iglesia con animación */}
        <div className="loading-icon-wrapper">
          <div className="loading-icon">⛪</div>
          <div className="loading-ring"></div>
        </div>

        {/* Mensaje de carga */}
        <h1 className="loading-title">Confiésalo</h1>

        {/* Indicador de puntos animados */}
        <div className="loading-dots">
          <span className="loading-text">Cargando</span>
          <span className="dots">{dots}</span>
        </div>

        {/* Barra de progreso animada */}
        <div className="loading-bar-container">
          <div className="loading-bar">
            <div className="loading-bar-progress"></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoadingComponent;
